/**
 * @file_purpose  page for showing candidate form details
 * @author Sucheta Singha
 * @Date_Created 27-02-2025
 * @Date_Modified 27-02-2025
 */
import React, { useCallback, useEffect, useRef, useState } from "react";
import {
    CButton,
    CCol,
    CDataTable,
    CRow,
    CLabel,
    CInput,
    CModalBody,
    CSwitch,
    CCard, CForm, CSpinner,
    CTextarea, CSelect, CFormGroup
} from '@coreui/react'
import moment from 'moment';
import { ToastContainer, toast } from 'react-toastify';
import { useHistory } from 'react-router-dom'
import Constants from 'src/Utility/Constants';
import { Modal } from 'react-bootstrap';
import OnBoardingService from "src/apis/OnBoardingService";
import Helpers from 'src/Utility/Helpers';
import Service from 'src/apis/Service';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import RouteURL from "src/apis/ApiURL";
import helpers from 'src/Utility/Helpers';
import masterData from 'src/Utility/MasterData';
import logout from "../../../assets/icons/logout.png";
import logo from "../../../assets/icons/visitor_logo.png"
import defaultImg from "../../../assets/icons/user.png";



const OnBoardCandidateForm = (props) => {

    var accessToken = localStorage.getItem("candidate_onboard_auth_token");
    const history = useHistory();

    //Define states
    const [loadingData, setLoadingData] = useState(true);
    var [date, setDate] = useState(new Date());
    const [isActive, setIsActive] = useState(false)
    //Define states
    const [state, setState] = useState({
        address_proof_attachment: '',
        pan_no: '',
        pan_card_attachment: '',
        aadhaar_no: '',
        aadhar_card_attachment: '',
        account_holder_name: '',
        bank_name: '',
        bank_account_number: '',
        bank_ifsc: '',
        bank_address: '',
        bank_cheque_attachment: '',
        resume: '',
        current_offer_letter_attachment: '',
        prev_offer_letter_attachment: '',
        releiving_letter_attachment: '',
        payslip_attachment: '',
        bank_statement_attachment: '',
        candidate_photo: '',
        uan_no: '',
        is_pf_account_exists: 0,
        address_proof_attachment_view: '',
        pan_card_attachment_view: '',
        aadhar_card_attachment_view: '',
        bank_cheque_attachment_view: '',
        resume_view: '',
        current_offer_letter_attachment_view: '',
        prev_offer_letter_attachment_view: '',
        releiving_letter_attachment_view: '',
        payslip_attachment_view: [],
        bank_statement_attachment_view: [],

    })

    const [img, setImg] = useState()
    const [tentativeDOJ, setTentativeDOJ] = useState()
    const [educationFileModal, setEducationFileModal] = useState(false)
    const [deleteEducationModal, SetDeleteEducationModal] = useState(false)
    const [finalSubmitModal, setFinalSubmitModal] = useState(false)
    const [educationModal, setEducationModal] = useState(false);
    const [educationList, setEducationList] = useState([]);
    const [educationId, setEducationId] = useState();
    const [educationDetails, setEducationDetails] = useState([]);
    const [degreeErrors, setDegreeErrors] = useState();
    const [yOCErrors, setYOCErrors] = useState();
    const [yOJErrors, setYOJErrors] = useState();
    const [universityErrors, setUniversityErrors] = useState();
    const [bankStatementAttachmentErrors, setBankStatementAttachmentErrors] = useState();
    const [payslipAttachmentError, setPayslipAttachmentErrors] = useState();
    const [submitDisable, setSubmitDisable] = useState(false);
    useEffect(() => {
        if (!accessToken) {
            localStorage.removeItem('candidate_onboard_auth_token');
            history.push(`/onboarding-candidate/${localStorage.getItem("candidate_onboard_token")}`);
            window.location.reload();
        }
        toast.dismiss();

        /**
          * @author Sucheta Singha
          * @Date_Created 
          * @Date_Modified 22/02/2023
          * @function async
          * @functionName loadUserDetails
          * @functionPurpose this function gets user details by user id.
          *
          * @functionParam {query params:user_id}
          * 
          * @functionSuccess Success status and message.
          *
          * @functionError {Boolean} error is there.
          * @functionError {String} message  Description message.
          */
        async function loadUserDetails() {
            OnBoardingService.apiGetCallRequest(RouteURL.getOnBoardingCandidateOTPVerificationDetails)
                .then((res) => {
                    if (res.message === "jwt expired") {
                        localStorage.clear();
                        history.push("/login")
                        window.location.reload();
                    }
                    if (res.status === Constants.API_RESPONSE_STATUS_SUCCESS) {

                        const data = res?.data[0];
                        if (res?.data.length > 0) {

                            setState(prevState => ({
                                ...prevState,
                                address_proof_attachment_view: helpers.checkNull(data.address_proof_attachment),
                                pan_no: helpers.checkNull(data.pan_no),
                                pan_card_attachment_view: helpers.checkNull(data.pan_card_attachment),
                                aadhaar_no: helpers.checkNull(data.aadhhar_no),
                                aadhar_card_attachment_view: helpers.checkNull(data.aadhar_card_attachment),
                                account_holder_name: helpers.checkNull(data.account_holder_name),
                                bank_name: helpers.checkNull(data.bank_name),
                                bank_account_number: helpers.checkNull(data.bank_account_number),
                                bank_ifsc: helpers.checkNull(data.bank_ifsc),
                                bank_address: helpers.checkNull(data.bank_address),
                                bank_cheque_attachment_view: helpers.checkNull(data.bank_cheque_attachment),
                                resume_view: helpers.checkNull(data.resume),
                                current_offer_letter_attachment_view: helpers.checkNull(data.current_offer_letter_attachment),
                                prev_offer_letter_attachment_view: helpers.checkNull(data.prev_offer_letter_attachment),
                                releiving_letter_attachment_view: helpers.checkNull(data.releiving_letter_attachment),
                                payslip_attachment_view: helpers.checkNull(data.payslip_attachment),
                                bank_statement_attachment_view: helpers.checkNull(data.bank_statement_attachment),
                                picture: helpers.checkNull(data.candidate_photo),
                                is_pf_account_exists: data.is_pf_account_exists != null ? data.is_pf_account_exists : 0,
                                uan_no: data.is_pf_account_exists == 1 ? data.uan_no : "",
                            }))


                            if (data.tentative_doj != null) {
                                setTentativeDOJ(new Date(data.tentative_doj))
                            }
                        }


                        setLoadingData(false)
                    }
                    else {
                        toast.error(res.message, {
                            position: toast.POSITION.BOTTOM_RIGHT
                        });
                    }
                }).catch(error => {
                    console.log(error);

                })
        }


        if (loadingData) {
            ListOfEducation()
            loadUserDetails();

        }



    }, [loadingData]);



    const handleChange = (e) => {
        var newValue
        if (e.target.type == "checkbox") {
            const { id, checked } = e.target
            newValue = checked ? 1 : 0
            setState(prevState => ({
                ...prevState,
                [id]: newValue
            }))

        }
        else {
            const { id, value } = e.target
            newValue = value
            setState(prevState => ({
                ...prevState,
                [id]: newValue
            }))

        }
    }

    const handleChangePF = (e) => {
        var newValue
        const { id, checked } = e.target
        newValue = checked ? 1 : 0
        setState(prevState => ({
            ...prevState,
            is_pf_account_exists: newValue,
            uan_no: newValue == 0 ? "" : state.uan_no,
        }))

    }

    const handleChangeFile = (e) => {
        const imgUrl = URL.createObjectURL(e.target.files[0]);
        const { id, value } = e.target
        if (id == "candidate_photo") {
            setImg(imgUrl);
        }

        setState(prevState => ({
            ...prevState,
            [id]: e.target.files[0]
        }))
    }

    const handleChangeMultipleFile = (e) => {
        const { id } = e.target
        setState(prevState => ({
            ...prevState,
            [id]: e.target.files
        }))

    }


    const inputRef = useRef(null);
    const handleClick = () => {
        // 👇️ open file input box on click of other element
        inputRef.current.click();
    };


    //open education modal
    const OpenEducationModal = (e, education_id) => {
        setState(prevState => ({
            ...prevState,
            degree: '',
            percentage: '',
            year_of_completion: '',
            year_of_joining: '',
            university: '',
            education_attachment: '',
        }))
        setEducationModal(!educationModal);
    }

    /* Validate all fields for education*/
    const handleDetailsValidation = (e) => {
        let payslipAttachmentError, bankStatementAttachmentError;
        let formIsValid = true;
        //Payslip Attachment
        if (state.payslip_attachment?.length > 0) {
            if (state.payslip_attachment.length != 3) {
                formIsValid = false;
                payslipAttachmentError = "You have to attach last 3 month payslip";
                setPayslipAttachmentErrors(payslipAttachmentError);
            }
        } else {
            setPayslipAttachmentErrors('');
        }

        //Bank Statement Attachment
        if (state.bank_statement_attachment?.length > 0) {
            if (state.bank_statement_attachment.length != 3) {
                formIsValid = false;
                bankStatementAttachmentError = "You have to attach last 3 month bank statement";
                setBankStatementAttachmentErrors(bankStatementAttachmentError);
            }
        } else {
            setBankStatementAttachmentErrors('');
        }

        return formIsValid;
    }

    /* Validation Checking */
    const ValidateForm = (e) => {
        e.preventDefault();
        if (handleDetailsValidation()) {
            UpdateUserSubmitClick();
        }


    }



    /**
      * @author Sucheta Singha
      * @Date_Created 
      * @Date_Modified 22/02/2023
      * @function sync
      * @functionName UpdateUserSubmitClick
      * @functionPurpose this function add and edit user details.
      *
      * @functionParam {payload object:fullname,email,employment_id,
      * employment_type,present_address,permanent_address,phone,mobile,father_name,
      * designation_id,joining_date,date_of_birth,pan_no,aadhhar_no,employment_status,
      * probation_end_date,release_date,location_id,reporting_manager_id,personal_email,
      * company_id,work_location,work_location_note,medical_insurance_no,gender,
      * flexible_time,recruiter_id,uan_no,picture,user_id,is_team_lead}
      * 
      * @functionSuccess Success status and message.
      *
      * @functionError {Boolean} error is there.
      * @functionError {String} message  Description message.
      */
    const UpdateUserSubmitClick = (e) => {
        setIsActive(true);
        setSubmitDisable(true)
        //Using Formdata  
        const formData = new FormData();
        formData.append("pan_no", state.pan_no ? state.pan_no : "");
        formData.append("aadhhar_no", state.aadhaar_no ? state.aadhaar_no : "");
        formData.append("account_holder_name", state.account_holder_name ? state.account_holder_name : "");
        formData.append("bank_name", state.bank_name ? state.bank_name : "");
        formData.append("bank_account_number", state.bank_account_number ? state.bank_account_number : "");
        formData.append("bank_ifsc", state.bank_ifsc ? state.bank_ifsc : "");
        formData.append("bank_address", state.bank_address ? state.bank_address : "");
        formData.append("tentative_doj", tentativeDOJ ? moment(tentativeDOJ).format("YYYY-MM-DD") : "");

        formData.append("is_pf_account_exists", state.is_pf_account_exists != null ? state.is_pf_account_exists : 0);
        formData.append("uan_no", state.is_pf_account_exists == 1 ? state.uan_no : "");

        if (state.address_proof_attachment) {
            formData.append("address_proof_attachment", state.address_proof_attachment);
        }
        if (state.pan_card_attachment) {
            formData.append("pan_card_attachment", state.pan_card_attachment);
        }
        if (state.aadhar_card_attachment) {
            formData.append("aadhar_card_attachment", state.aadhar_card_attachment);
        }
        if (state.candidate_photo) {
            formData.append("candidate_photo", state.candidate_photo);
        }
        if (state.resume) {
            formData.append("resume", state.resume);
        }
        if (state.current_offer_letter_attachment) {
            formData.append("current_offer_letter_attachment", state.current_offer_letter_attachment);
        }
        if (state.prev_offer_letter_attachment) {
            formData.append("prev_offer_letter_attachment", state.prev_offer_letter_attachment);
        }
        if (state.releiving_letter_attachment) {
            formData.append("releiving_letter_attachment", state.releiving_letter_attachment);
        }
        for (var i = 0; i < state.payslip_attachment?.length; i++) {
            formData.append("payslip_attachment", state.payslip_attachment[i]);
        }

        for (var i = 0; i < state.bank_statement_attachment?.length; i++) {
            formData.append("bank_statement_attachment", state.bank_statement_attachment[i]);
        }

        if (state.bank_cheque_attachment) {
            formData.append("bank_cheque_attachment", state.bank_cheque_attachment);
        }
        let params = formData

        OnBoardingService.apiPostCallRequest(RouteURL.updateOnBoardingCandidateDetails, params)
            .then((res) => {
                if (res.status === Constants.API_RESPONSE_STATUS_SUCCESS) {
                    setIsActive(false);
                    setSubmitDisable(false)
                    setState(prevState => ({
                        ...prevState,
                        address_proof_attachment_view: '',
                        pan_no: '',
                        pan_card_attachment: '',
                        aadhaar_no: '',
                        aadhar_card_attachment: '',
                        account_holder_name: '',
                        bank_name: '',
                        bank_account_number: '',
                        bank_ifsc: '',
                        bank_address: '',
                        bank_cheque_attachment: '',
                        resume_view: '',
                        current_offer_letter_attachment: '',
                        prev_offer_letter_attachment: '',
                        releiving_letter_attachment: '',
                        payslip_attachment: '',
                        bank_statement_attachment: '',
                    }))
                    setLoadingData(true)
                    toast.success(res.message, {
                        position: toast.POSITION.BOTTOM_RIGHT
                    });
                }
                else {
                    setSubmitDisable(false)
                    setIsActive(false);
                    toast.error(res.message, {
                        position: toast.POSITION.BOTTOM_RIGHT
                    });
                }
            }).catch(error => {
                console.log(error);
            })


    }

    /* Validation Checking for education modal*/
    const ValidateEducationForm = (e) => {
        e.preventDefault();
        if (handleEducationValidation()) {
            EducationModalSubmit();
        }
        else {
            toast.error("Please fill all * fields !", {
                position: toast.POSITION.BOTTOM_RIGHT
            });
        }
    }

    /* For opening delete education modal */
    const OpenEducationDeleteModal = (e, education_id) => {
        setEducationId(education_id)
        SetDeleteEducationModal(!deleteEducationModal)
    }

    /**
      * @author Sucheta Singha
      * @Date_Created 
      * @Date_Modified 22/02/2023
      * @function sync
      * @functionName EducationModalSubmit
      * @functionPurpose this function add education details for a particular employee.
      *
      * @functionParam {payload object:attachments,email,user_id,
      * degree,year_of_completion,percentage,year_of_joining,university}
      * 
      * @functionSuccess Success status and message.
      *
      * @functionError {Boolean} error is there.
      * @functionError {String} message  Description message.
      */
    const EducationModalSubmit = (e) => {
        setSubmitDisable(true)
        const formData = new FormData();

        formData.append("degree", state.degree);
        formData.append("year_of_completion", state.year_of_completion);
        formData.append("percentage", state.percentage == '' ? null : state.percentage);
        formData.append("year_of_joining", state.year_of_joining);
        formData.append("university", state.university);
        for (var i = 0; i < state.education_attachment?.length; i++) {
            formData.append("attachments", state.education_attachment[i]);
        }
        // formData.append("attachments", state.education_attachment);
        let params = formData
        OnBoardingService.apiPostCallFormDataRequest(RouteURL.addOnBoardingUserEducation, params)
            .then((res) => {
                if (res.status === Constants.API_RESPONSE_STATUS_SUCCESS) {
                    setSubmitDisable(false)
                    ListOfEducation();
                    setEducationModal(!educationModal);
                    toast.success(res.message, {
                        position: toast.POSITION.BOTTOM_RIGHT
                    });
                }
                else {
                    setSubmitDisable(false)
                    setEducationModal(!educationModal);
                    ListOfEducation();
                    toast.error(res.message, {
                        position: toast.POSITION.BOTTOM_RIGHT
                    });
                }
            }).catch(error => {
                console.log(error);
            })

    }


    /**
        * @author Sucheta Singha
        * @Date_Created 
        * @Date_Modified 22/02/2023
        * @function sync
        * @functionName ListOfEducation
        * @functionPurpose this function gets list of education for a particular employee.
        *
        * @functionParam {payload object:user_id}
        * 
        * @functionSuccess Success status and message.
        *
        * @functionError {Boolean} error is there.
        * @functionError {String} message  Description message.
        */
    const ListOfEducation = (e) => {
        OnBoardingService.apiGetCallRequest(RouteURL.onBoardingCandidateEducationList)
            .then((res) => {
                if (res.status === Constants.API_RESPONSE_STATUS_SUCCESS) {
                    setEducationList(res.data)
                }
            }).catch(error => {
                console.log(error);
            })

    }


    /* Validate all fields for education*/
    const handleEducationValidation = (e) => {
        let degreeErrors, yocErrors, percentageErrors, yojErrors, universityError, attachmentError;
        let formIsValid = true;


        //Degree
        if (!state.degree) {
            formIsValid = false;
            degreeErrors = "Degree can not be empty";
            setDegreeErrors(degreeErrors);
        } else {
            setDegreeErrors('');
        }

        //YOC
        if (!state.year_of_completion) {
            formIsValid = false;
            yocErrors = "Email can not be empty";
            setYOCErrors(yocErrors);
        } else {
            setYOCErrors('');
        }

        //Percentage
        // if (!state.percentage) {
        //   formIsValid = false;
        //   percentageErrors = "Percentage can not be empty";
        //   setPercentageErrors(percentageErrors);
        // } else {
        //   setPercentageErrors('');
        // }

        //Joining Date
        if (!state.year_of_joining) {
            formIsValid = false;
            yojErrors = "Joining date can not be empty";
            setYOJErrors(yojErrors);
        } else {
            setYOJErrors('');
        }

        //University
        if (!state.university) {
            formIsValid = false;

            universityError = "University can not be empty";
            setUniversityErrors(universityError);
        } else {
            setUniversityErrors('');
        }


        //Attachment
        // if (!state.education_attachment) {
        //   formIsValid = false;
        //   attachmentError = "Attachment can not be empty";
        //   setAttachmentErrors(attachmentError);
        // } else {
        //   setAttachmentErrors('');
        // }

        return formIsValid;
    }


    const GoBackClick = (e) => {
        e.preventDefault();
        history.goBack()
    }

    const handleChangeEducation = (e) => {
        var newValue
        if (e.target.type == "checkbox") {
            const { id, checked } = e.target
            newValue = checked ? 1 : 0
            setState(prevState => ({
                ...prevState,
                [id]: newValue
            }))

        }
        else {
            const { id, value } = e.target
            newValue = value
            setState(prevState => ({
                ...prevState,
                [id]: newValue
            }))

        }
    }

    const logoutSubmitClick = (e) => {
        window.location.reload();
        history.push(`/onboarding-candidate/${localStorage.getItem("candidate_onboard_token")}`);
        localStorage.removeItem("candidate_onboard_auth_token");

    }


    /**
          * @author Sucheta Singha
          * @Date_Created 
          * @Date_Modified 22/02/2023
          * @function sync
          * @functionName deleteEducation
          * @functionPurpose this function gets list of education for a particular employee.
          *
          * @functionParam {payload object:onboarding_candidate_education_id}
          * 
          * @functionSuccess Success status and message.
          *
          * @functionError {Boolean} error is there.
          * @functionError {String} message  Description message.
          */
    const deleteEducation = (e) => {
        setSubmitDisable(true)
        let params = JSON.stringify({
            onboarding_candidate_education_id: educationId,
        })
        OnBoardingService.apiPostCallRequest(RouteURL.deleteOnBoardingUserEducation, params)
            .then((res) => {
                if (res.status === Constants.API_RESPONSE_STATUS_SUCCESS) {
                    ListOfEducation();
                    setSubmitDisable(false)
                    SetDeleteEducationModal(!deleteEducationModal)
                }
                else {
                    ListOfEducation();
                    setSubmitDisable(false)
                    SetDeleteEducationModal(!deleteEducationModal)
                    toast.error(res.message, {
                        position: toast.POSITION.BOTTOM_RIGHT
                    });

                }
            }).catch(error => {
                console.log(error);
            })

    }

    const finalSubmitClick = (e) => {
        setSubmitDisable(true)
        OnBoardingService.apiGetCallRequest(RouteURL.onboardingFinalSubmission)
            .then((res) => {
                if (res.status === Constants.API_RESPONSE_STATUS_SUCCESS) {
                    setSubmitDisable(false)
                    setFinalSubmitModal(!finalSubmitClick)
                    localStorage.removeItem('candidate_onboard_auth_token');
                    localStorage.removeItem('candidate_onboard_verified');
                    history.push(`/onboarding-candidate/${localStorage.getItem("candidate_onboard_token")}`);
                }
                else {
                    setSubmitDisable(false)
                    setFinalSubmitModal(!finalSubmitClick)
                    toast.error(res.message, {
                        position: toast.POSITION.BOTTOM_RIGHT
                    });

                }
            }).catch(error => {
                console.log(error);
            })

    }



    const OpenEducationFileModal = (e, education_attachments) => {
        setEducationDetails(education_attachments)
        setEducationFileModal(!educationFileModal);
    }


    return (
        <>
            <ToastContainer />
            <header className="header_sec">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-3 col-sm-3 col-3">
                            <div className="visitor_hed">
                                <img src={logo} alt='' />
                            </div>
                        </div>
                        <div className="col-xxl-6 col-xl-6 col-lg-5 col-md-4 col-sm-12 d-none d-md-block"></div>
                        <div className="col-xxl-3 col-xl-3 col-lg-4 col-md-5 col-sm-9 col-9">
                            <div className="visitor_hed_rt">
                                <span className="visit_date">{moment(new Date().toJSON().slice(0, 10)).format("DD-MM-YYYY")} | <span className="visit_time">
                                    {date.toLocaleTimeString()}
                                </span></span>

                                <span className="visiter_logout_sec" onClick={(e) => logoutSubmitClick(e)}>
                                    <img src={logout} alt='' />
                                    <span className="logout_mob">Logout</span>
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
            </header>

            <CRow>
                <CCol style={{ margin: "20px" }}>

                    <div className="main_visitor">
                        <div className="row">
                            <div className="col-xxl-3 col-sm-6 col-xl-3 col-lg-4 col-md-4 col-sm-8 col-9">
                                <h6 className="visit_txt_hed">
                                    {/* Candidate On Boarding Process - <span>{moment(new Date().toJSON().slice(0, 10)).format("DD-MM-YYYY")}</span> */}
                                </h6>
                            </div>
                            <div className="col-xxl-7 col-xl-6 col-lg-6 col-md-5 col-sm-1 d-none d-md-block">
                                <div className="month_sec">

                                </div>
                            </div>
                            <div className="col-xxl-2 col-xl-3 col-lg-2 col-md-3 col-sm-4 col-3 visitor_add">
                            </div>

                        </div>


                        <CCard>
                            <div className="admin_emp_sec">
                                <CForm action="" method="post" encType="multipart/form-data" className="form-horizontal">
                                    {isActive ? (
                                        <div
                                            style={{
                                                display: "flex",
                                                justifyContent: "center",
                                                alignItems: "center",
                                                position: "absolute",
                                                width: "100%",
                                                marginTop: "50%",
                                            }}
                                        >
                                            {" "}
                                            <CSpinner
                                                style={{ width: "4rem", height: "4rem" }}
                                                color="danger"
                                                variant="grow"
                                                className="loader_z_index"
                                            />
                                            <div className="modal-backdrop fade show"></div>
                                        </div>

                                    ) : (
                                        ""
                                    )}
                                    <div className="row">
                                        <div className="col-sm-12">
                                            <CFormGroup row>
                                                <CCol md="12" className="text-center">
                                                    <h6 className="hed_txt">Candidate Photo</h6>
                                                </CCol>
                                                <div className="profile_main">
                                                    <div className="profile_sec_pic">
                                                        <img src={img ? img : (state.picture ? state.picture : defaultImg)} alt="" />
                                                        <div className="profile_camera" onClick={handleClick}>
                                                            <i className="fa fa-camera" aria-hidden="true"></i>
                                                        </div>
                                                    </div>
                                                    <input ref={inputRef} type="file" accept="image/*" id="candidate_photo" name="candidate_photo" onChange={handleChangeFile} style={{ display: 'none' }} />
                                                </div>

                                            </CFormGroup>
                                        </div>

                                        <div className="col-sm-12">
                                            <div className="row">
                                                <div className="col-sm-6">
                                                    <div className="personal_info basic_lt">
                                                        <h6>Identity & Address Proof Related Documents</h6>
                                                        <div className="row ">


                                                            <div className="col-sm-12 perso_inn">
                                                                <div className="row" >
                                                                    <CCol md="4">
                                                                        <CLabel htmlFor="text-input">Any one from the following Passport / Driving License / Voter ID Card: </CLabel>
                                                                    </CCol>
                                                                    <CCol xs="12" md="8">
                                                                        <CInput type="file" name="address_proof_attachment" id="address_proof_attachment"
                                                                            accept=".doc,.docx,.pdf,image/*"
                                                                            onChange={handleChangeFile} />
                                                                        {state.address_proof_attachment_view ?
                                                                            <a href={state.address_proof_attachment_view} target="_blank" rel="noopener noreferrer" download>
                                                                                <i className="fa fa-file" aria-hidden="true" style={{ fontSize: 60, color: "gray" }}></i>
                                                                            </a>
                                                                            : ""}

                                                                    </CCol>
                                                                </div>
                                                            </div>

                                                            <div className="col-sm-12 perso_inn">
                                                                <div className="row" >
                                                                    <CCol md="4">
                                                                        <CLabel htmlFor="text-input">PAN No </CLabel>
                                                                    </CCol>
                                                                    <CCol xs="12" md="8">
                                                                        <CInput name="pan_no" id="pan_no" placeholder="Enter PAN No" value={state.pan_no} onChange={handleChange} />

                                                                    </CCol>
                                                                </div>
                                                            </div>

                                                            <div className="col-sm-12 perso_inn">
                                                                <div className="row" >
                                                                    <CCol md="4">
                                                                        <CLabel htmlFor="text-input">PAN Card: </CLabel>
                                                                    </CCol>
                                                                    <CCol xs="12" md="8">
                                                                        <CInput type="file" name="pan_card_attachment" id="pan_card_attachment"
                                                                            accept=".doc,.docx,.pdf,image/*"
                                                                            onChange={handleChangeFile} />
                                                                        {state.pan_card_attachment_view ?
                                                                            <a href={state.pan_card_attachment_view} target="_blank" rel="noopener noreferrer" download>
                                                                                <i className="fa fa-file" aria-hidden="true" style={{ fontSize: 60, color: "gray" }}></i>
                                                                            </a>
                                                                            : ""}
                                                                    </CCol>
                                                                </div>
                                                            </div>

                                                            <div className="col-sm-12 perso_inn">
                                                                <div className="row" >
                                                                    <CCol md="4">
                                                                        <CLabel htmlFor="text-input">Aadhaar No </CLabel>
                                                                    </CCol>
                                                                    <CCol xs="12" md="8">
                                                                        <CInput name="aadhaar_no" id="aadhaar_no" placeholder="Enter AADHAAR No" value={state.aadhaar_no} onChange={handleChange} />

                                                                    </CCol>
                                                                </div>
                                                            </div>

                                                            <div className="col-sm-12 perso_inn">
                                                                <div className="row" >
                                                                    <CCol md="4">
                                                                        <CLabel htmlFor="text-input">Aadhar Card: </CLabel>
                                                                    </CCol>
                                                                    <CCol xs="12" md="8">
                                                                        <CInput type="file" name="aadhar_card_attachment" id="aadhar_card_attachment"
                                                                            accept=".doc,.docx,.pdf,image/*"
                                                                            onChange={handleChangeFile} />
                                                                        {state.aadhar_card_attachment_view ?
                                                                            <a href={state.aadhar_card_attachment_view} target="_blank" rel="noopener noreferrer" download>
                                                                                <i className="fa fa-file" aria-hidden="true" style={{ fontSize: 60, color: "gray" }}></i>
                                                                            </a>
                                                                            : ""}
                                                                    </CCol>
                                                                </div>
                                                            </div>

                                                        </div>
                                                    </div>
                                                </div>


                                                <div className="col-sm-6">
                                                    <div className="personal_info basic_lt">
                                                        <h6>Employment Related Documents:</h6>
                                                        <div className="row ">

                                                            <div className="col-sm-12 perso_inn">
                                                                <div className="row" >
                                                                    <CCol md="4">
                                                                        <CLabel htmlFor="text-input">Do you ever had PF? </CLabel>
                                                                    </CCol>
                                                                    <CCol xs="12" md="4">
                                                                        <CSwitch
                                                                            className="mr-1"
                                                                            color="primary"
                                                                            name="is_pf_account_exists"
                                                                            id="is_pf_account_exists"
                                                                            checked={state.is_pf_account_exists}
                                                                            onChange={handleChangePF}

                                                                        />
                                                                    </CCol>

                                                                </div>
                                                            </div>
                                                            {state.is_pf_account_exists == 1 &&
                                                                <div className="col-sm-12 perso_inn">
                                                                    <div className="row" >
                                                                        <CCol md="4">
                                                                            <CLabel htmlFor="text-input">UAN Number </CLabel>
                                                                        </CCol>
                                                                        <CCol xs="12" md="4">
                                                                            <CInput name="uan_no" id="uan_no" type="text" placeholder="Enter UAN Number" value={state.uan_no} onChange={handleChange} />
                                                                        </CCol>

                                                                    </div>
                                                                </div>
                                                            }


                                                            <div className="col-sm-12 perso_inn">
                                                                <div className="row" >
                                                                    <CCol md="4">
                                                                        <CLabel htmlFor="text-input">Offer/Appointment Letter from your current organization: </CLabel>
                                                                    </CCol>
                                                                    <CCol xs="12" md="8">
                                                                        <CInput type="file" name="current_offer_letter_attachment" id="current_offer_letter_attachment"
                                                                            accept=".doc,.docx,.pdf,image/*"
                                                                            onChange={handleChangeFile} />
                                                                        {state.current_offer_letter_attachment_view ?
                                                                            <a href={state.current_offer_letter_attachment_view} target="_blank" rel="noopener noreferrer" download>
                                                                                <i className="fa fa-file" aria-hidden="true" style={{ fontSize: 60, color: "gray" }}></i>
                                                                            </a>
                                                                            : ""}
                                                                    </CCol>
                                                                </div>
                                                            </div>
                                                            <div className="col-sm-12 perso_inn">
                                                                <div className="row" >
                                                                    <CCol md="4">
                                                                        <CLabel htmlFor="text-input">Offer/Appointment Letter from your previous company: </CLabel>
                                                                    </CCol>
                                                                    <CCol xs="12" md="8">
                                                                        <CInput type="file" name="prev_offer_letter_attachment" id="prev_offer_letter_attachment"
                                                                            accept=".doc,.docx,.pdf,image/*"
                                                                            onChange={handleChangeFile} />
                                                                        {state.prev_offer_letter_attachment_view ?
                                                                            <a href={state.prev_offer_letter_attachment_view} target="_blank" rel="noopener noreferrer" download>
                                                                                <i className="fa fa-file" aria-hidden="true" style={{ fontSize: 60, color: "gray" }}></i>
                                                                            </a>
                                                                            : ""}
                                                                    </CCol>
                                                                </div>
                                                            </div>

                                                            <div className="col-sm-12 perso_inn">
                                                                <div className="row" >
                                                                    <CCol md="4">
                                                                        <CLabel htmlFor="text-input">Relieving Letter from your previous company: </CLabel>
                                                                    </CCol>
                                                                    <CCol xs="12" md="8">
                                                                        <CInput type="file" name="releiving_letter_attachment" id="releiving_letter_attachment"
                                                                            accept=".doc,.docx,.pdf,image/*"
                                                                            onChange={handleChangeFile} />
                                                                        {state.releiving_letter_attachment_view ?
                                                                            <a href={state.releiving_letter_attachment_view} target="_blank" rel="noopener noreferrer" download>
                                                                                <i className="fa fa-file" aria-hidden="true" style={{ fontSize: 60, color: "gray" }}></i>
                                                                            </a>
                                                                            : ""}
                                                                    </CCol>
                                                                </div>
                                                            </div>

                                                            <div className="col-sm-12 perso_inn">
                                                                <div className="row" >
                                                                    <CCol md="4">
                                                                        <CLabel htmlFor="text-input">Last 3 months' Payslips: </CLabel>
                                                                    </CCol>
                                                                    <CCol xs="12" md="8">
                                                                        <CInput type="file" name="payslip_attachment" id="payslip_attachment"
                                                                            accept=".doc,.docx,.pdf,image/*" multiple="multiple"
                                                                            onChange={handleChangeMultipleFile} />
                                                                        <span style={{ color: "red" }}>{payslipAttachmentError}</span>
                                                                        <CFormGroup row>
                                                                            {state.payslip_attachment_view && state.payslip_attachment_view?.map((fileDetails, index) => (
                                                                                <CCol md="4" style={{ marginBottom: 10 }}>
                                                                                    <a href={fileDetails} target='_blank' rel='noopener noreferrer'>
                                                                                        <i className="fa fa-file" aria-hidden="true" style={{ fontSize: 60, color: "gray" }}></i>
                                                                                    </a>

                                                                                </CCol>
                                                                            ))}
                                                                        </CFormGroup>
                                                                    </CCol>
                                                                </div>
                                                            </div>
                                                            <div className="col-sm-12 perso_inn">
                                                                <div className="row" >
                                                                    <CCol md="4">
                                                                        <CLabel htmlFor="text-input">Last 3 months' Bank Statements: </CLabel>
                                                                    </CCol>
                                                                    <CCol xs="12" md="8">
                                                                        <CInput type="file" name="bank_statement_attachment" id="bank_statement_attachment"
                                                                            accept=".doc,.docx,.pdf,image/*" multiple="multiple"
                                                                            onChange={handleChangeMultipleFile} />
                                                                        <span style={{ color: "red" }}>{bankStatementAttachmentErrors}</span>
                                                                        <CFormGroup row>
                                                                            {state.bank_statement_attachment_view && state.bank_statement_attachment_view?.map((fileDetails, index) => (
                                                                                <CCol md="4" style={{ marginBottom: 10 }}>
                                                                                    <a href={fileDetails} target='_blank' rel='noopener noreferrer'>
                                                                                        <i className="fa fa-file" aria-hidden="true" style={{ fontSize: 60, color: "gray" }}></i>
                                                                                    </a>

                                                                                </CCol>
                                                                            ))}
                                                                        </CFormGroup>
                                                                    </CCol>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>


                                            </div>
                                        </div>
                                        <div className="col-sm-12">
                                            <div className="row mt-3">

                                                <div className="col-sm-6">
                                                    <div className="personal_info box_ht basic_lt">


                                                        <h6>Bank Details</h6>
                                                        <div className="row">


                                                            <div className="col-sm-12 perso_inn">
                                                                <div className="row" >
                                                                    <CCol md="4">
                                                                        <CLabel htmlFor="text-input">Account Holder Name</CLabel>
                                                                    </CCol>
                                                                    <CCol xs="12" md="8">
                                                                        <CInput name="account_holder_name" id="account_holder_name" placeholder="Enter account holder name" value={state.account_holder_name} onChange={handleChange} />
                                                                    </CCol>
                                                                </div>
                                                            </div>

                                                            <div className="col-sm-12 perso_inn">
                                                                <div className="row" >
                                                                    <CCol md="4">
                                                                        <CLabel htmlFor="text-input">Bank Name</CLabel>
                                                                    </CCol>
                                                                    <CCol xs="12" md="8">
                                                                        <CInput name="bank_name" id="bank_name" placeholder="Enter bank name" value={state.bank_name} onChange={handleChange} />
                                                                    </CCol>
                                                                </div>
                                                            </div>

                                                            <div className="col-sm-12 perso_inn">
                                                                <div className="row" >
                                                                    <CCol md="4">
                                                                        <CLabel htmlFor="text-input">Bank Account Number </CLabel>
                                                                    </CCol>
                                                                    <CCol xs="12" md="8">
                                                                        <CInput name="bank_account_number" id="bank_account_number" placeholder="Enter account number" value={state.bank_account_number} onChange={handleChange} />
                                                                    </CCol>
                                                                </div>
                                                            </div>

                                                            <div className="col-sm-12 perso_inn">
                                                                <div className="row" >
                                                                    <CCol md="4">
                                                                        <CLabel htmlFor="text-input">IFSC Code</CLabel>
                                                                    </CCol>
                                                                    <CCol xs="12" md="8">
                                                                        <CInput name="bank_ifsc" id="bank_ifsc" placeholder="Enter ifsc code" value={state.bank_ifsc} onChange={handleChange} />
                                                                    </CCol>
                                                                </div>
                                                            </div>

                                                            <div className="col-sm-12 perso_inn">
                                                                <div className="row" >
                                                                    <CCol md="4">
                                                                        <CLabel htmlFor="text-input">Bank Address</CLabel>
                                                                    </CCol>
                                                                    <CCol xs="12" md="8">
                                                                        <CTextarea
                                                                            name="bank_address"
                                                                            id="bank_address"
                                                                            rows="4"
                                                                            placeholder="Enter bank address..."
                                                                            value={state.bank_address}
                                                                            onChange={handleChange}
                                                                        />
                                                                    </CCol>
                                                                </div>
                                                            </div>

                                                            <div className="col-sm-12 perso_inn">
                                                                <div className="row" >
                                                                    <CCol md="4">
                                                                        <CLabel htmlFor="text-input">Upload Cancelled Cheque</CLabel>
                                                                    </CCol>
                                                                    <CCol xs="12" md="8">
                                                                        <CInput type="file" name="bank_cheque_attachment" id="bank_cheque_attachment"
                                                                            accept=".doc,.docx,.pdf,image/*"
                                                                            onChange={handleChangeFile} />
                                                                        {state.bank_cheque_attachment_view ?
                                                                            <a href={state.bank_cheque_attachment_view} target="_blank" rel="noopener noreferrer" download>
                                                                                <i className="fa fa-file-pdf-o" aria-hidden="true" style={{ fontSize: 60, color: "gray" }}></i>
                                                                            </a>
                                                                            : ""}
                                                                    </CCol>
                                                                </div>
                                                            </div>




                                                        </div>
                                                    </div>
                                                </div>


                                                <div className="col-sm-6">
                                                    <div className="personal_info basic_lt">
                                                        <h6>Resume</h6>
                                                        <div className="row ">


                                                            <div className="col-sm-12 perso_inn">
                                                                <div className="row" >
                                                                    <CCol md="4">
                                                                        <CLabel htmlFor="text-input">Resume:  </CLabel>
                                                                    </CCol>
                                                                    <CCol xs="12" md="8">
                                                                        <CInput type="file" name="resume" id="resume"
                                                                            accept=".pdf"
                                                                            onChange={handleChangeFile} />
                                                                        {state.resume_view ?
                                                                            <a href={state.resume_view} target="_blank" rel="noopener noreferrer" download>
                                                                                <i className="fa fa-file-pdf-o" aria-hidden="true" style={{ fontSize: 60, color: "gray" }}></i>
                                                                            </a>
                                                                            : ""}
                                                                    </CCol>
                                                                </div>
                                                            </div>

                                                            <div className="col-sm-12 perso_inn">
                                                                <div className="row" >
                                                                    <CCol md="4">
                                                                        <CLabel htmlFor="text-input">Tentative Date of Joining </CLabel>
                                                                    </CCol>
                                                                    <CCol xs="12" md="8">
                                                                        <DatePicker name="tentative_doj" id="tentative_doj" className="date_sec"
                                                                            showMonthDropdown
                                                                            showYearDropdown
                                                                            dropdownMode="select"
                                                                            selected={tentativeDOJ}

                                                                            minDate={new Date()}
                                                                            wrapperClassName="datePicker"
                                                                            placeholderText="dd-MM-yyyy"
                                                                            onChange={(date) => setTentativeDOJ(date)}
                                                                            dateFormat="dd-MM-yyyy"
                                                                        />
                                                                    </CCol>
                                                                </div>
                                                            </div>



                                                        </div>
                                                    </div>
                                                </div>

                                            </div>
                                        </div>
                                        <div className="comp_off_inn">
                                            <div className="atten_sec1" style={{ textAlign: 'center' }}>
                                                <CButton size="lg" className="save" onClick={ValidateForm} disabled={submitDisable ? true : false}> Save</CButton>

                                            </div>
                                        </div>

                                        <hr />

                                        <div className="col-sm-12 mt-3">

                                            <div className="personal_info basic_lt">
                                                <h6>Education Related Documents:</h6>
                                                <div className="row">


                                                    <div className="back_verification_sec">
                                                        <div className="brdr pt-0" style={{ display: "flex", justifyContent: "space-between", alignItems: "center", paddingBottom: 0 }}>

                                                            {
                                                                (educationList.length > 0) && <>
                                                                    <span className="plus_sec" style={{ cursor: 'pointer' }} onClick={(e) => OpenEducationModal(e, "")}><i className="fa fa-plus" aria-hidden="true"></i> </span>
                                                                </>}
                                                        </div>
                                                        {
                                                            (educationList.length <= 0) && <>
                                                                <div className="data_no_sec">
                                                                    <p>No Data Available</p>
                                                                    <button className="button_design_emp" type="button" value="submit" onClick={(e) => OpenEducationModal(e, "")}>Add Education</button>
                                                                </div>
                                                            </>}

                                                        <div className="row">
                                                            {educationList && educationList.map((educationDetails, index) => (
                                                                <div className="col-sm-4">

                                                                    <div className="education_list">

                                                                        <div style={{ cursor: 'pointer', width: "98%", textAlign: "right" }} onClick={(e) => OpenEducationDeleteModal(e, educationDetails.onboarding_candidate_education_id)}>
                                                                            <span className="trash_sec" style={{ color: 'red' }}><i className="fa-solid fa-trash-can" aria-hidden="true"></i></span>
                                                                        </div>
                                                                        <div className="col-sm-12" >
                                                                            <div className="brdr">
                                                                                <div className="row">
                                                                                    <CCol sm="12">
                                                                                        <CFormGroup row className="mb-0">
                                                                                            <CCol md="6" lg="7" xl="7" sm="12">
                                                                                                <CLabel className="title" htmlFor="text-input">Degree: </CLabel>
                                                                                            </CCol>
                                                                                            <CCol xs="12" md="6" lg="5" xl="5" sm="12">
                                                                                                <CLabel className="text" htmlFor="text-input">{educationDetails.degree}</CLabel>
                                                                                            </CCol>
                                                                                        </CFormGroup>
                                                                                    </CCol>
                                                                                </div>
                                                                            </div>


                                                                            <div className="brdr">
                                                                                <div className="row">
                                                                                    <CCol sm="12">
                                                                                        <CFormGroup row className="mb-0">
                                                                                            <CCol md="6" lg="7" xl="7" sm="12">
                                                                                                <CLabel className="title" htmlFor="text-input">Year of Completion: </CLabel>
                                                                                            </CCol>
                                                                                            <CCol xs="12" md="6" lg="5" xl="5" sm="12">
                                                                                                <CLabel className="text" htmlFor="text-input">{educationDetails.year_of_completion}</CLabel>
                                                                                            </CCol>
                                                                                        </CFormGroup>
                                                                                    </CCol>
                                                                                </div>
                                                                            </div>

                                                                            <div className="brdr">
                                                                                <div className="row">
                                                                                    <CCol sm="12">
                                                                                        <CFormGroup row className="mb-0">
                                                                                            <CCol md="6" lg="7" xl="7" sm="12">
                                                                                                <CLabel className="title" htmlFor="text-input">Grade / Percentage: </CLabel>
                                                                                            </CCol>
                                                                                            <CCol xs="12" md="6" lg="5" xl="5" sm="12">
                                                                                                <CLabel className="text" htmlFor="text-input">{educationDetails.percentage}</CLabel>
                                                                                            </CCol>
                                                                                        </CFormGroup>
                                                                                    </CCol>
                                                                                </div>
                                                                            </div>

                                                                            <div className="brdr">
                                                                                <div className="row">
                                                                                    <CCol sm="12">
                                                                                        <CFormGroup row className="mb-0">
                                                                                            <CCol md="6" lg="7" xl="7" sm="12">
                                                                                                <CLabel className="title" htmlFor="text-input">Year of Joining: </CLabel>
                                                                                            </CCol>
                                                                                            <CCol xs="12" md="6" lg="5" xl="5" sm="12">
                                                                                                <CLabel className="text" htmlFor="text-input">{educationDetails.year_of_joining}</CLabel>
                                                                                            </CCol>
                                                                                        </CFormGroup>
                                                                                    </CCol>
                                                                                </div>
                                                                            </div>

                                                                            <div className="brdr">
                                                                                <div className="row">
                                                                                    <CCol sm="12">
                                                                                        <CFormGroup row className="mb-0">
                                                                                            <CCol md="6" lg="7" xl="7" sm="12">
                                                                                                <CLabel className="title" htmlFor="text-input">University / College / School: </CLabel>
                                                                                            </CCol>
                                                                                            <CCol xs="12" md="6" lg="5" xl="5" sm="12">
                                                                                                <CLabel className="text" htmlFor="text-input">{educationDetails.university}</CLabel>
                                                                                            </CCol>
                                                                                        </CFormGroup>
                                                                                    </CCol>
                                                                                </div>
                                                                            </div>

                                                                            {educationDetails.attachments && educationDetails.attachments.length > 0 &&
                                                                            <div className="list_inn">

                                                                                <div className="button_design_emp" style={{ cursor: 'pointer', width: "auto", textAlign: "center", float: "left" }}
                                                                                    onClick={(e) => OpenEducationFileModal(e, educationDetails.attachments)}
                                                                                >View Attachment</div>
                                                                            </div>
                                                                        }

                                                                            
                                                                        </div>

                                                                    </div>
                                                                </div>
                                                            ))}
                                                        </div>


                                                    </div>


                                                </div>
                                            </div>
                                        </div>



                                        <div className="comp_off_inn">
                                            <div className="atten_sec1" style={{ textAlign: 'center' }}>
                                                <CButton size="lg" className="save"
                                                    onClick={(e) => setFinalSubmitModal(!finalSubmitModal)}> Final Submit</CButton>

                                            </div>
                                        </div>

                                    </div>



                                </CForm>
                            </div>
                        </CCard>
                    </div>

                    {/*add education form modal */}
                    < Modal
                        show={educationModal}
                        onHide={() => setEducationModal(!educationModal)}
                        backdrop="static"
                    >

                        <div className="apply_comp_sec">
                            <Modal.Header closeButton >
                                <h6 className="hed_txt">Education Details</h6>
                            </Modal.Header>

                            <div className="comp_inner_sec">
                                <div className="comp_off_inn">
                                    <div className="row">

                                        <div className="col-md-6 " style={{ paddingBottom: "10px" }}>

                                            <CLabel htmlFor="text-input">Degree <span style={{ color: "red" }}>*</span></CLabel>
                                            <CInput name="degree" id="degree" placeholder="Enter Degree" value={state.degree} onChange={handleChangeEducation} />
                                            <span style={{ color: "red" }}>{degreeErrors}</span>
                                        </div>

                                        <div className="col-md-6 " style={{ paddingBottom: "10px" }}>
                                            <CLabel htmlFor="text-input">Year of Joining <span style={{ color: "red" }}>*</span></CLabel>
                                            <CInput name="year_of_joining" id="year_of_joining" placeholder="Enter year" value={state.year_of_joining} onChange={handleChangeEducation} />
                                            <span style={{ color: "red" }}>{yOJErrors}</span>
                                        </div>

                                        <div className="col-md-6 " style={{ paddingBottom: "10px" }}>

                                            <CLabel htmlFor="text-input">Year of Completion <span style={{ color: "red" }}>*</span></CLabel>
                                            <CInput name="year_of_completion" id="year_of_completion" placeholder="Enter year" value={state.year_of_completion} onChange={handleChangeEducation} />
                                            <span style={{ color: "red" }}>{yOCErrors}</span>
                                        </div>



                                        <div className="col-md-6 " style={{ paddingBottom: "10px" }}>
                                            <CLabel htmlFor="text-input">University / College / School <span style={{ color: "red" }}>*</span></CLabel>
                                            <CInput name="university" id="university" placeholder="Enter university" value={state.university} onChange={handleChangeEducation} />
                                            <span style={{ color: "red" }}>{universityErrors}</span>
                                        </div>
                                        <div className="col-md-6 " style={{ paddingBottom: "10px" }}>
                                            <CLabel htmlFor="text-input">Grade / Percentage </CLabel>
                                            <CInput name="percentage" id="percentage" placeholder="Enter Percentage" value={state.percentage} onChange={handleChangeEducation} />
                                            {/* <span style={{ color: "red" }}>{percentageErrors}</span> */}
                                        </div>
                                        <div className="col-md-6 " style={{ paddingBottom: "10px" }}>
                                            <CLabel htmlFor="text-input"> Attachment </CLabel>

                                            <div className="choose_file">
                                                <div className="upload-btn-wrapper">
                                                    <button className="btn-custom">Choose file</button>
                                                    <input type="file" name="education_attachment" id="education_attachment" accept=".doc,.docx,.pdf,image/*" multiple="multiple" placeholder="Attachment" onChange={handleChangeMultipleFile}
                                                    // ref={ref}
                                                    />
                                                </div>
                                                {/* <p>{state.education_attachment ? state.education_attachment[0].name : "No file chosen"}</p> */}

                                            </div>

                                        </div>

                                    </div>
                                </div>
                            </div>

                            <div className="comp_off_inn">
                                <div className="row">
                                    <div className="atten_sec1 col-12">
                                        <CButton className="save"
                                            disabled={submitDisable ? true : false}
                                            style={{ marginRight: 10 }}
                                            onClick={ValidateEducationForm}
                                        >
                                            Save
                                        </CButton>
                                    </div>
                                </div>
                            </div>
                        </div>


                    </Modal >


                    {/*view education file modal */}
                    < Modal
                        show={educationFileModal}
                        onHide={() => setEducationFileModal(!educationFileModal)}
                        backdrop="static"
                    >

                        <div className="apply_comp_sec">
                            <Modal.Header closeButton >
                                <h6 className="hed_txt">File Details</h6>
                            </Modal.Header>

                            <div className="comp_inner_sec">
                                <div className="comp_off_inn">
                                    <div className="row">
                                        <div className="col-md-12">
                                            {isActive ?
                                                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', position: 'absolute', width: '100%', marginTop: 10 }}> <CSpinner
                                                    style={{ width: '2rem', height: '2rem', }}
                                                    color="danger"
                                                    variant="grow"
                                                    className="loader_z_index"
                                                />
                                                </div>
                                                : ""}
                                            <CFormGroup row>
                                                {educationDetails.map((educationFileDetails, index) => (
                                                    <CCol md="4" style={{ marginBottom: 10 }}>
                                                        <a href={educationFileDetails} target='_blank' rel='noopener noreferrer'>

                                                            <i className="fa fa-file" aria-hidden="true" style={{ fontSize: 60, color: "gray" }}></i>
                                                        </a>

                                                    </CCol>
                                                ))}
                                            </CFormGroup>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Modal >


                    {/*delete education modal */}
                    < Modal
                        show={deleteEducationModal}
                        onHide={() => SetDeleteEducationModal(!deleteEducationModal)}
                        backdrop="static"
                    >

                        <div className="apply_comp_sec">
                            <Modal.Header closeButton >
                                <h6 className="hed_txt">Delete Education</h6>
                            </Modal.Header>

                            <div className="comp_inner_sec">
                                <div className="comp_off_inn">
                                    <div className="row">
                                        <div className="col-md-12">
                                            <CLabel style={{ textAlign: 'center' }}>Do you want to delete this education?</CLabel>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="comp_off_inn">
                                <div className="row">
                                    <div className="atten_sec1 col-12">
                                        <CButton className="cancel" style={{ marginRight: 10 }} onClick={() => SetDeleteEducationModal(!deleteEducationModal)}>
                                            No
                                        </CButton>
                                        <CButton className="save"
                                            disabled={submitDisable ? true : false}
                                            onClick={e => deleteEducation(e)}
                                        >
                                            Yes
                                        </CButton>

                                    </div>
                                </div>
                            </div>
                        </div>


                    </Modal >


                    {/*delete education modal */}
                    < Modal
                        show={finalSubmitModal}
                        onHide={() => setFinalSubmitModal(!finalSubmitModal)}
                        backdrop="static"
                    >

                        <div className="apply_comp_sec">
                            <Modal.Header closeButton >
                                <h6 className="hed_txt">Final Submit</h6>
                            </Modal.Header>

                            <div className="comp_inner_sec">
                                <div className="comp_off_inn">
                                    <div className="row">
                                        <div className="col-md-12">
                                            <CLabel style={{ textAlign: 'center' }}>Do you want to submit this?</CLabel>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="comp_off_inn">
                                <div className="row">
                                    <div className="atten_sec1 col-12">
                                        <CButton className="cancel" style={{ marginRight: 10 }} onClick={() => setFinalSubmitModal(!finalSubmitModal)}>
                                            No
                                        </CButton>
                                        <CButton className="save"
                                            disabled={submitDisable ? true : false}
                                            onClick={e => finalSubmitClick(e)}
                                        >
                                            Yes
                                        </CButton>

                                    </div>
                                </div>
                            </div>
                        </div>


                    </Modal >







                </CCol>



            </CRow>
        </>
    )
}
export default OnBoardCandidateForm
